<script setup lang="ts">
import type { CmsIconName } from '@pkg/cms-icons';
import CmsIcon from '../../inner/Tiles/CmsIcon.vue';

const props = defineProps<{
  vendorType: string;
  iconName?: CmsIconName;
  selected?: boolean;
}>();

const emit = defineEmits(['select']);
</script>

<template>
  <button
    :class="`panel ${props.selected ? 'panel--selected' : ''}`"
    type="button"
    @click="emit('select')"
  >
    <CmsIcon v-if="props.iconName" class="panel-icon" :name="props.iconName" />
    <span class="text-h5">
      {{ props.vendorType }}
    </span>
  </button>
</template>

<style scoped>
.panel {
  align-items: center;
  background-color: var(--s-f-panel-background-color);
  border: 1px solid var(--s-f-panel-border-color);
  color: var(--s-f-panel-text-color);
  display: flex;
  gap: 8px;
  height: 48px;
  padding: 0.5rem;
  text-align: left;
  text-transform: uppercase;
  width: 152px;
  transition: background-color,border,color theme('transitionDuration.goat') ease-out;

  @screen desk {
    align-items: center;
    gap: 20px;
    flex-direction: column;
    height: 180px;
    justify-content: center;
    padding: 1.5rem;
    text-align: center;
    width: 180px;
  }

  &.panel--selected {
    background-color: var(--s-f-panel-active-background-color);
    color: var(--s-f-panel-active-text-color);

    &:hover {
      color: var(--s-f-panel-active-text-hover-color);
      border-color: var(--s-f-panel-active-border-hover-color);
    }
  }

  &:hover {
    color: var(--s-f-panel-text-hover-color);
    border-color: var(--s-f-panel-border-hover-color);
  }
}

.panel-icon {
  font-size: 27px;

  @screen desk {
    font-size: 56px;
  }
}
</style>
